import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector, MemoizedSelector,
} from '@ngrx/store';
import * as _ from 'lodash';
import * as fromRoot from '../../shared/reducers';
import {ShippingsListReducer, shippingsListSelectors, ShippingsState} from './shippings-list';
import {ShippingsFilter, ShippingsList} from '../models/shippings-list';
import {siteSummariesdSelectors, SiteSummariesReducer, SiteSummariesState} from './site-summaries';
import {Shipping, SiteSummary} from '../models/shipping';
import {ShippingReducer, shippingSelectors, ShippingState} from './shipping';
import { AddressSummariesReducer, addressSummariesSelectors, AddressSummariesState} from './address-summaries';
import { AddressSummaries} from '../../shared/models/address';

export interface ShippingsStates {
  shippingsList: ShippingsState;
  siteSummaries: SiteSummariesState;
  addressSummaries: AddressSummariesState;
  shipping: ShippingState;
}

export interface AppState extends fromRoot.AppState {
  shippings: ShippingsState;
  siteSummaries: SiteSummariesState;
  addressSummaries: AddressSummariesState;
  shipping: ShippingState;
}

export const reducers: ActionReducerMap<ShippingsStates> = {
  shippingsList: ShippingsListReducer,
  siteSummaries: SiteSummariesReducer,
  addressSummaries: AddressSummariesReducer,
  shipping: ShippingReducer,
};

const getShippingState = createFeatureSelector('shippings');

const rootSelectors = {
  shippingsList: createSelector(getShippingState, (state: ShippingsStates) => _.get(state, 'shippingsList')),
  siteSummaries: createSelector(getShippingState, (state: ShippingsStates) => _.get(state, 'siteSummaries')),
  addrresSummaries: createSelector(getShippingState, (state: ShippingsStates) => _.get(state, 'addressSummaries')),
  shipping: createSelector(getShippingState, (state: ShippingsStates) => _.get(state, 'shipping'))
};

export interface Selectors {
  getShippingFilter: MemoizedSelector<AppState, ShippingsFilter |  string | number>;
  getShippingQuickSearch: MemoizedSelector<AppState, string>;
  getShippingBy: MemoizedSelector<AppState, string>;
  getShippings: MemoizedSelector<AppState, ShippingsList[]>;
  getShippingCount: MemoizedSelector<AppState, number>;
  getShippingPageSize: MemoizedSelector<AppState, number>;
  getShippingPage: MemoizedSelector<AppState, number>;
  getShippingShowFilter: MemoizedSelector<AppState, boolean>;
  getSiteSummaries: MemoizedSelector<AppState, SiteSummary>;
  getAddressSummaries: MemoizedSelector<AppState, AddressSummaries[]>;
  getShipping: MemoizedSelector<AppState, Shipping>;
}

export const selectors: Selectors = {
  getShippingFilter: createSelector(rootSelectors.shippingsList, shippingsListSelectors.filter),
  getShippingQuickSearch: createSelector(rootSelectors.shippingsList, shippingsListSelectors.quickSearch),
  getShippingBy: createSelector(rootSelectors.shippingsList, shippingsListSelectors.orderBy),
  getShippings: createSelector(rootSelectors.shippingsList, shippingsListSelectors.array),
  getShippingCount: createSelector(rootSelectors.shippingsList, shippingsListSelectors.count),
  getShippingPageSize: createSelector(rootSelectors.shippingsList, shippingsListSelectors.pageSize),
  getShippingPage: createSelector(rootSelectors.shippingsList, shippingsListSelectors.page),
  getShippingShowFilter: createSelector(rootSelectors.shippingsList, shippingsListSelectors.showFilter),
  getSiteSummaries: createSelector(rootSelectors.siteSummaries, siteSummariesdSelectors.siteSummaries),
  getAddressSummaries: createSelector(rootSelectors.addrresSummaries, addressSummariesSelectors.addressSummaries),
  getShipping: createSelector(rootSelectors.shipping, shippingSelectors.shipping),
};

